import React from "react";
import Seo from "../../components/seo";
import Industry from "../../layouts/Industries/Industry";
import {graphql, useStaticQuery} from 'gatsby';
import Layout from "../../components/layout";
import {Communication} from '../../components/svgs/industries';

const CommunicationIndustryPageFr = () => {
  const data = useStaticQuery(graphql`
    query CommunicationIndustryDatasFr {
      allContentfulSecteurs(filter: {contentful_id: {eq: "1uJmaotvSb75OCUDrKeY6o"}}) {
        edges {
          node {
            name
            permalink
            contentful_id
            advantages {
              title
              description
              icon
              visual {
                gatsbyImageData(layout: CONSTRAINED)
              }
            }
            installations {
              gatsbyImageData(layout: CONSTRAINED)
            }
            clients {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
      }
    }
  `)

  return (
    <Layout 
    slider={false} 
    switchLink={data.allContentfulSecteurs.edges[1].node.permalink} 
    lang="fr-CA"
    title={data.allContentfulSecteurs.edges[0].node.name} 
    subTitle="L'affichage dynamique en"
    icon={<Communication/>}>
      <Seo 
        title="Utilisez l'affchage dynamique pour vos communications internes en entreprise"
        description="Communiquez vos objectifs et résultats, tout en mobilisant votre équipe grâce à l'affichage dynamique qui peut s'ajuster rapidement à toutes les situations."
       />
      <Industry datas={data.allContentfulSecteurs.edges[0].node}/>
    </Layout>
  )
}

export default CommunicationIndustryPageFr
